






import Vue from 'vue'
import { oneOf } from '@/utils/helper'

export default Vue.extend({
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md',
      validator: oneOf(['sm', 'md'])
    }
  },
  computed: {
    sizeClassName(): string {
      return `-${this.size}`
    }
  }
})
